import { render, staticRenderFns } from "./add-basic.vue?vue&type=template&id=184d1420&scoped=true&"
import script from "./add-basic.vue?vue&type=script&lang=ts&"
export * from "./add-basic.vue?vue&type=script&lang=ts&"
import style0 from "./add-basic.vue?vue&type=style&index=0&id=184d1420&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d1420",
  null
  
)

export default component.exports